/* RINSE — claude 2 theme interactions */
(function () {
  "use strict";

  function buildNozzles(group, cx, cy, rings) {
    if (!group) return;
    let out = "";
    out += `<circle cx="${cx}" cy="${cy}" r="2.4" />`;
    for (let ring = 1; ring <= rings; ring++) {
      const radius = ring * (cy === 190 ? 13 : 11);
      const count = ring * 6;
      for (let i = 0; i < count; i++) {
        const a = (i / count) * Math.PI * 2;
        out += `<circle cx="${(cx + Math.cos(a) * radius).toFixed(1)}" cy="${(cy + Math.sin(a) * radius).toFixed(1)}" r="2.2" />`;
      }
    }
    group.innerHTML = out;
  }
  buildNozzles(document.getElementById("nozzles"), 180, 190, 6);
  buildNozzles(document.getElementById("nozzles2"), 150, 170, 6);

  const revealEls = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add("is-in"));
  }

  const header = document.getElementById("header");
  const buybar = document.getElementById("buybar");
  const hero = document.querySelector(".hero");
  const onScroll = () => {
    const y = window.scrollY;
    if (header) header.classList.toggle("is-stuck", y > 12);
    const heroBottom = hero ? hero.getBoundingClientRect().height + (hero.offsetTop || 0) : 600;
    const nearBottom = window.innerHeight + y > document.body.offsetHeight - 220;
    const show = y > heroBottom * 0.6 && !nearBottom;
    if (buybar) { buybar.classList.toggle("is-visible", show); buybar.setAttribute("aria-hidden", show ? "false" : "true"); }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  const burger = document.getElementById("burger");
  const menu = document.getElementById("mobileMenu");
  if (burger && menu) {
    const toggleMenu = (open) => {
      burger.classList.toggle("is-open", open);
      menu.classList.toggle("is-open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      menu.setAttribute("aria-hidden", open ? "false" : "true");
      document.body.style.overflow = open ? "hidden" : "";
    };
    burger.addEventListener("click", () => toggleMenu(!burger.classList.contains("is-open")));
    menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => toggleMenu(false)));
  }

  const reportForm = document.getElementById("reportForm");
  if (reportForm) {
    const zipInput = document.getElementById("zipInput");
    const placeholder = document.getElementById("reportPlaceholder");
    const result = document.getElementById("reportResult");
    const zipLabel = document.getElementById("zipLabel");
    const hardVal = document.getElementById("hardVal");
    const HARD = ["Soft", "Moderate", "Hard", "Very hard"];
    reportForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const zip = (zipInput.value || "").replace(/\D/g, "").slice(0, 5);
      if (zip.length < 5) { zipInput.focus(); return; }
      zipLabel.textContent = "ZIP " + zip;
      hardVal.textContent = HARD[(parseInt(zip[4], 10) + 1) % HARD.length] || "Moderate";
      placeholder.hidden = true;
      result.hidden = false;
    });
  }

  const finishes = document.getElementById("finishes");
  const finishLabel = document.getElementById("finishLabel");
  const shopHead = document.querySelector(".shop__head");
  if (finishes) {
    finishes.addEventListener("click", (e) => {
      const btn = e.target.closest(".finish");
      if (!btn) return;
      finishes.querySelectorAll(".finish").forEach((f) => f.classList.remove("is-active"));
      btn.classList.add("is-active");
      if (finishLabel) finishLabel.textContent = btn.dataset.finish;
      const tint = { "Matte Black": .55, "Navy": .35, "Brushed Gold": .25, "Brushed Chrome": 0 }[btn.dataset.finish] || 0;
      if (shopHead) shopHead.style.filter = `drop-shadow(0 24px 30px rgba(11,37,69,.3)) saturate(${1 - tint}) brightness(${1 - tint * 0.35})`;
    });
  }

  let PLANS = null;
  const planDataEl = document.getElementById("planData");
  if (planDataEl) { try { PLANS = JSON.parse(planDataEl.textContent); } catch (e) { PLANS = null; } }
  const els = {
    tabs: document.querySelectorAll(".plan__tab"),
    amount: document.getElementById("planAmount"),
    strike: document.getElementById("planStrike"),
    per: document.getElementById("planPer"),
    btn: document.getElementById("addBtn")
  };
  const setPlan = (key) => {
    if (!PLANS || !PLANS[key]) return;
    const p = PLANS[key];
    if (els.amount) els.amount.textContent = p.amount;
    if (els.strike) { els.strike.textContent = p.strike || ""; els.strike.style.display = p.strike ? "" : "none"; }
    if (els.per) els.per.textContent = p.per;
    if (els.btn) els.btn.textContent = p.cta;
    els.tabs.forEach((t) => t.classList.toggle("is-active", t.dataset.plan === key));
  };
  els.tabs.forEach((t) => t.addEventListener("click", () => setPlan(t.dataset.plan)));

  const cartCount = document.querySelector(".nav__count");
  let count = 0;
  if (els.btn) {
    els.btn.addEventListener("click", () => {
      count += 1;
      if (cartCount) cartCount.textContent = count;
      const original = els.btn.textContent;
      els.btn.textContent = "✓ Added to cart";
      els.btn.style.background = "var(--navy-600)";
      setTimeout(() => { els.btn.textContent = original; els.btn.style.background = ""; }, 1400);
    });
  }

  const tabs = document.getElementById("concernTabs");
  const cText = document.getElementById("concernText");
  const cName = document.getElementById("concernName");
  if (tabs && cText && cName) {
    tabs.addEventListener("click", (e) => {
      const chip = e.target.closest(".chip");
      if (!chip) return;
      tabs.querySelectorAll(".chip").forEach((c) => c.classList.remove("is-active"));
      chip.classList.add("is-active");
      cText.style.opacity = "0";
      setTimeout(() => {
        cText.textContent = chip.dataset.quote || "";
        cName.innerHTML = (chip.dataset.name || "") + ' <span>' + (chip.dataset.meta || "") + "</span>";
        cText.style.opacity = "1";
      }, 180);
    });
  }

  const accs = document.querySelectorAll(".acc");
  accs.forEach((acc) => acc.addEventListener("toggle", () => {
    if (acc.open) accs.forEach((o) => o !== acc && (o.open = false));
  }));

  const form = document.getElementById("newsForm");
  const note = document.getElementById("newsNote");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      form.reset();
      if (note) { note.textContent = "You're in — check your inbox for 10% off."; note.style.color = "var(--blue)"; }
    });
  }

  const fmt = (n) => n.toLocaleString("en-US");
  const runCount = (el) => {
    const target = parseInt(el.dataset.count, 10) || 0;
    const suffix = el.dataset.suffix || "";
    const dur = 1400, start = performance.now();
    const step = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const counters = document.querySelectorAll("[data-count]");
  if (counters.length && "IntersectionObserver" in window) {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.5 });
    counters.forEach((c) => cio.observe(c));
  } else {
    counters.forEach((c) => (c.textContent = fmt(parseInt(c.dataset.count, 10) || 0) + (c.dataset.suffix || "")));
  }

  const docs = document.getElementById("docs");
  const dotsWrap = document.getElementById("docDots");
  if (docs && dotsWrap) {
    const slides = Array.from(docs.querySelectorAll(".doc"));
    let idx = 0, timer;
    slides.forEach((_, i) => {
      const b = document.createElement("button");
      b.setAttribute("aria-label", "Show quote " + (i + 1));
      if (i === 0) b.classList.add("is-active");
      b.addEventListener("click", () => { go(i); restart(); });
      dotsWrap.appendChild(b);
    });
    const dots = Array.from(dotsWrap.children);
    const go = (n) => {
      slides[idx].classList.remove("is-active");
      dots[idx].classList.remove("is-active");
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add("is-active");
      dots[idx].classList.add("is-active");
    };
    const restart = () => { clearInterval(timer); timer = setInterval(() => go(idx + 1), 5000); };
    if (slides.length > 1) restart();
  }
})();
